import { createContext, useCallback, useState } from 'react';
// eslint-disable-next-line import/no-unresolved -- this file is created during BE build
import { applicationMode } from 'workflowVersion';
import { useStyles } from '@signavio/ui';
import { Stack } from '@signavio/ui/core';
import { utils } from '../../styles';
import { VariableUtils } from '../../utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DevToolsContext = /*#__PURE__*/createContext([() => {
  throw new Error('Cannot register dev-tool outside of a provider.');
}, () => {
  throw new Error('Cannot unregister dev-tool outside of a provider.');
}, Object.freeze({})]);
const DevTools = ({
  children
}) => {
  const styles = useStyles(defaultStyles, {});
  const [devTools, setDevTools] = useState([]);
  const [portals, setPortals] = useState(Object.freeze({}));
  const registerDevTool = useCallback(() => {
    const id = VariableUtils.provideId();
    setDevTools(devToolIds => [...devToolIds, id]);
    return id;
  }, []);
  const unregisterDevTool = useCallback(id => {
    setDevTools(devToolIds => devToolIds.filter(devToolId => devToolId !== id));
  }, []);
  return /*#__PURE__*/_jsxs(DevToolsContext.Provider, {
    value: [registerDevTool, unregisterDevTool, portals],
    children: [children, applicationMode !== 'prod' && /*#__PURE__*/_jsx("div", {
      ...styles,
      children: /*#__PURE__*/_jsx(Stack, {
        spacing: "small",
        children: devTools.map(id => /*#__PURE__*/_jsx("div", {
          ref: node => {
            if (!portals[id] && node) {
              setPortals(portals => ({
                ...portals,
                [id]: node
              }));
            }
          }
        }, id))
      })
    })]
  });
};
const defaultStyles = ({
  color,
  font,
  lineHeight,
  spacing
}) => {
  const headerHeight = utils.calculateHeight(font.size.normal, lineHeight, spacing.small);
  return {
    position: 'fixed',
    marginLeft: headerHeight,
    bottom: spacing.xsmall,
    left: spacing.xsmall,
    background: 'white',
    padding: spacing.xsmall,
    ...utils.border(1, 'solid', color.mono.light),
    ...utils.boxShadow()
  };
};
export default DevTools;